














import { defineComponent, getCurrentInstance } from "@vue/composition-api";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "HelpLink",
  components: {},
  props: {
    url: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  setup() {
    const instance = getCurrentInstance();
    const handleClick = (gaEventCategory: string) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `ヘッダー_${gaEventCategory}`
        });
      }
    };

    return {
      handleClick
    };
  }
});
